export default "__VITE_ASSET__Do$ctta1__"